module.exports = __webpack_public_path__ + "static/media/GeojiDark.24513347.svg";